<template lang='pug'>
  div
    v-autocomplete(label='Search to Add Suites'
      @input='add'
      :loading='loading'
      :items='available'
      v-model='suite'
      hide-selected
      item-text='name'
      :search-input.sync='search'
      return-object)
      template(v-slot:no-data)
        v-list-item
          v-list-item-content
            v-list-item-title
              | No suites matching &quot;
              strong {{ search }}
              | &quot;
      template(v-slot:item='{item}')
        v-list-item-content
          v-list-item-title(v-text='item.name')
          v-list-item-subtitle(v-text='item.description')
    sortable-list(ref='sortableList' :value='value' @input='update' no-items='No Suites')
      template(v-slot:row='{item, index}')
        div {{ item.name }}
        v-spacer
        v-btn(text icon :to='`/testsuite/${item.guid}`' target='_blank')
          v-icon edit
        v-btn(text icon @click='remove(item)')
          v-icon delete
</template>

<script>
import {debounce} from 'lodash';
import SortableList from './SortableList';
import TestSuite from '../api/testSuite';
import Notifications from '../services/notification.service';

export default {
  name: 'BionicMetricsSuiteList',
  components: {SortableList},
  props: {
    dashboard: {
      type: Object
    },
    value: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      try {
        this.loading = true;
        const projection = {
          name: true,
          description: true,
          guid: true,
          testSuite: '$_id',
          tests: true // so we get the tiles
        };
        const limit = 40;
        const {list} = await TestSuite.list({limit, projection, search: this.search});
        this.available = list;
      } catch (error) {
        Notifications.errorToast('Error Loading Test Suites', {
          duration: 30000,
          retry: this.load
        });
      } finally {
        this.loading = false;
      }
    },
    add(testSuite) {
      if (this.value.find((ts) => ts.guid === testSuite.guid)) return Notifications.alert(`<strong>${testSuite.name}</strong> is already on this dashboard. You can only add a suite to a dashboard once.`);
      this.$emit('input', [...this.value, testSuite]);
      this.$nextTick(() => {
        this.search = null;
        this.suite = null;
        this.$refs.sortableList.scrollToBottom();
      });
    },
    async remove(testSuite) {
      // eslint-disable-next-line max-len
      const yes = await Notifications.confirm('Remove', `Are you sure you want to remove <strong>${testSuite.name}</strong> from <strong>${this.dashboard.name}</strong>? This will also remove any Run Configurations or Notifications associated with <strong>${testSuite.name}</strong>.`);
      if (!yes) return;
      this.$emit('input', this.value.filter((v) => v.guid !== testSuite.guid));
      this.$emit('removed', testSuite.guid);
    },
    update(reordered) {
      this.$emit('input', reordered);
    }
  },
  watch: {
    // eslint-disable-next-line
    search: debounce(function (val) {
      this.load(val);
    }, 250)
  },
  data() {
    return {
      loading: false,
      search: null,
      suite: null,
      available: []
    };
  }
};
</script>

<style scoped>

</style>
